import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "year",
    "header",
    "column",
    "data"
  ];

  connect() {
console.log(
    this.dataTarget.textContent
  );

  this.months = JSON.parse(
    this.dataTarget.textContent
  );

  console.log(this.months);

    
    this.months = JSON.parse(
      this.dataTarget.textContent
    );

    console.log("calendar data");
    console.log(this.months);

    this.weekOffset = 0;

    this.render();

    requestAnimationFrame(() => {
      this.scrollToCurrentHour();
      this.highlightCurrentHour();
    });

    this.timer = setInterval(() => {
      if (this.weekOffset === 0) {
        this.render();
        this.highlightCurrentHour();
      }
    }, 60000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  previousWeek() {
    this.weekOffset -= 1;

    this.render();
  }

  nextWeek() {
    this.weekOffset += 1;

    this.render();
  }

  today() {
    this.weekOffset = 0;

    this.render();

    requestAnimationFrame(() => {
      this.scrollToCurrentHour();
      this.highlightCurrentHour();
    });
  }

  render() {
    const days = this.visibleDays();

    this.yearTarget.textContent =
      this.yearFor(days);

    days.forEach((day, index) => {
      this.renderDay(
        day,
        this.headerTargets[index],
        this.columnTargets[index]
      );
    });

    this.highlightCurrentHour();
  }

  renderDay(day, header, column) {
    header.textContent =
      this.formatDisplayDate(day.date);

    header.dataset.date = day.date;

    const dayColumn =
      column.closest(".calendar-day");

    const isCurrentWeek =
      this.weekOffset === 0;

    if (
      day.isToday &&
      isCurrentWeek
    ) {
      header.classList.add(
        "calendar-day__header--today",
        "background-primary"
      );

      dayColumn.classList.add(
        "calendar-day--today"
      );
    } else {
      header.classList.remove(
        "calendar-day__header--today",
        "background-primary"
      );

      dayColumn.classList.remove(
        "calendar-day--today"
      );
    }

    column
      .querySelectorAll(".calendar-slot")
      .forEach(slot => {
        const eventsContainer =
          slot.querySelector(
            ".calendar-slot__events"
          );

        eventsContainer.innerHTML = "";

        const time =
          slot.dataset.time;

        const events = day.events.filter(
          event => event.time === time
        );

        events.forEach(event => {
          const node =
            document.createElement("div");

          node.classList.add(
            "calendar-event",
            "border-black",
            "border",
            "p-3",
            "mt-3",
            "font-weight-bold"
          );

          if (event.url) {
            const link =
              document.createElement("a");

            link.href = event.url;
            link.target = "_blank";
            link.rel =
              "noopener noreferrer";

            link.textContent =
              event.title;

            node.appendChild(link);
          } else {
            node.textContent =
              event.title;
          }

          eventsContainer.appendChild(
            node
          );
        });

        if (events.length === 0) {
          slot.classList.add(
            "calendar-slot--empty"
          );

          slot.classList.remove(
            "calendar-slot--has-events"
          );
        } else {
          slot.classList.remove(
            "calendar-slot--empty"
          );

          slot.classList.add(
            "calendar-slot--has-events"
          );
        }
      });
  }

  scrollToCurrentHour() {
    if (this.weekOffset !== 0)
      return;

    const currentHour =
      String(
        new Date().getHours()
      ).padStart(2, "0") + ":00";

    this.columnTargets.forEach(
      column => {
        const slot =
          column.querySelector(
            `[data-time="${currentHour}"]`
          );

        if (!slot) return;

        slot.scrollIntoView({
          block: "center"
        });
      }
    );
  }

  highlightCurrentHour() {
    document
      .querySelectorAll(
        ".calendar-slot--current"
      )
      .forEach(slot => {
        slot.classList.remove(
          "calendar-slot--current"
        );
      });

    if (this.weekOffset !== 0)
      return;

    const currentHour =
      String(
        new Date().getHours()
      ).padStart(2, "0") + ":00";

    document
      .querySelectorAll(
        `[data-time="${currentHour}"]`
      )
      .forEach(slot => {
        slot.classList.add(
          "calendar-slot--current"
        );
      });
  }

  visibleDays() {
    const today = new Date();

    return Array.from(
      { length: 7 },
      (_, index) => {
        const date = new Date(today);

        date.setDate(
          date.getDate() +
          (this.weekOffset * 7) +
          index -
          3
        );

        const formatted =
          this.formatDate(date);

        return {
          date: formatted,
          isToday:
            formatted ===
            this.formatDate(today),
          events:
            this.eventsFor(
              formatted
            )
        };
      }
    );
  }

  eventsFor(dateString) {
    const month =
      dateString.slice(0, 7);

    return (
      this.months?.[month]?.[
        dateString
      ] || []
    );
  }

  yearFor(days) {
    return days[3].date.slice(0, 4);
  }

  formatDisplayDate(dateString) {
    const [, month, day] =
      dateString.split("-");

    return `${parseInt(
      day,
      10
    )}/${month}`;
  }

  formatDate(date) {
    const year =
      date.getFullYear();

    const month = String(
      date.getMonth() + 1
    ).padStart(2, "0");

    const day = String(
      date.getDate()
    ).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
}